import { slice } from './slice';

export const {
	selectOutdoorPhotos,
	selectOutdoorPhotosStatus,
	selectOutdoorPhotosDealId
} = slice.selectors;

export { loadOutdoorPhotos } from './slice';
export type { State as OutdoorPhotosState } from './state.type';
